module.exports = __webpack_public_path__ + "static/media/user-icon-5.02802330.png";